import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Footer from '../common/Footer';
import { Bars3Icon } from '@heroicons/react/24/outline';
import Logo from '../common/Logo';

export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  
  // Auto-minimize sidebar for chat to maximize conversation space
  const isChatRoute = location.pathname === '/chat';
  const sidebarMinimal = isChatRoute;
  const sidebarWidth = sidebarMinimal ? 'w-16' : 'w-64';
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      {/* Mobile header */}
      <div className="lg:hidden flex items-center justify-between p-4 border-b border-gray-800">
        <button
          className="text-gray-400 hover:text-white"
          onClick={toggleSidebar}
        >
          <Bars3Icon className="h-6 w-6" />
        </button>
        <Logo />
        <div className="w-6"></div> {/* Empty div for equal spacing */}
      </div>

      <div className="flex flex-1">
        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-10 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}
        
        {/* Sidebar */}
        <div 
          className={`
            fixed lg:sticky top-0 inset-y-0 left-0 z-20 
            transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
            lg:translate-x-0 transition-transform duration-200 ease-in-out
            bg-gray-900 ${sidebarWidth} flex-shrink-0 h-screen
          `}
        >
          <Sidebar 
            closeSidebar={() => setSidebarOpen(false)} 
            minimal={sidebarMinimal}
            inPlaybookLayout={false} 
          />
        </div>
        
        {/* Main content */}
        <div className="flex-1 flex flex-col min-w-0">
          <main className="flex-1 overflow-y-auto py-6 px-4 sm:px-6 lg:pl-6 lg:pr-8">
            <Outlet />
          </main>

          {/* Footer - Hide footer on chat to maximize space */}
          {!isChatRoute && <Footer />}
        </div>
      </div>
    </div>
  );
} 